<p>Effective Date: May 25, 2018</p>
<span class="blue">{{ 'PRIVACYPOLICY.H1.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H1.TEXT' | translate }}</p>
<span class="blue">{{ 'PRIVACYPOLICY.H2.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H2.TEXT' | translate }}</p>
<span class="blue">{{ 'PRIVACYPOLICY.H3.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H3.TEXT' | translate }}: </p>
<ul>
  <li>{{ 'PRIVACYPOLICY.H3.LI1' | translate }}</li>
  <li>{{ 'PRIVACYPOLICY.H3.LI2' | translate }}</li>
  <li>{{ 'PRIVACYPOLICY.H3.LI3' | translate }}</li>
</ul>
<span class="blue">{{ 'PRIVACYPOLICY.H4.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H4.TEXT' | translate }}</p>
<span class="blue">{{ 'PRIVACYPOLICY.H5.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H5.TEXT' | translate }}</p>
<span class="blue">{{ 'PRIVACYPOLICY.H6.TITLE' | translate }}</span>
<p>Go to <a routerLink="/">www.veexinc.com</a>, {{ 'PRIVACYPOLICY.H6.TEXT' | translate }}</p>
<span class="blue">{{ 'PRIVACYPOLICY.H7.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H7.TEXT' | translate }}</p>
<span class="blue">{{ 'PRIVACYPOLICY.H8.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H8.TEXT' | translate }} </p>
<span class="blue">{{ 'PRIVACYPOLICY.H9.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H9.TEXT' | translate }} (<a
    href="mailto:marketing@veexinc.com?subject=unsubscribe">unsubscribe</a>). </p>
<span class="blue">{{ 'PRIVACYPOLICY.H10.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H10.TEXT' | translate }} <a routerLink="/company/termsofuse">{{ 'FOOTER.TERMSOFUSE' | translate }}</a>.
</p>
<span class="blue">{{ 'PRIVACYPOLICY.H11.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H11.TEXT' | translate }} </p>
<span class="blue">{{ 'PRIVACYPOLICY.H12.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H12.TEXT' | translate }} </p>
<span class="blue">{{ 'PRIVACYPOLICY.H13.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H13.TEXT' | translate }}</p>
<span class="blue">{{ 'PRIVACYPOLICY.H14.TITLE' | translate }}</span>
<p>{{ 'PRIVACYPOLICY.H14.TEXT' | translate }}</p>
<p>{{ 'PRIVACYPOLICY.QUESTIONP' | translate }}<a href="mailto:privacy@veexinc.comsubject=Privacy%20Policy">
    privacy&#64;veexinc.com</a>
</p>
